
import api from "../utils/axios";

export async function getArticles({
    page = 1,
    categoryId = "",
    search = "",
    sort = "latest",
    perPage = 12,
} = {}) {
    const response = await api.get(`/magazine`, {
        params: {
            page,
            category: categoryId || undefined,
            search: search || undefined,
            sort,
            per_page: perPage,
        },
    });

    return response.data;
}

export async function getArticleBySlug(slug) {
    const response = await api.get(
        `/magazine/${slug}`
    );

    return response.data;
}



// export const articleService = {
//     async getHomeArticles() {
//         try {
//             const { data } = await api.get("/home/articles");

//             return data.data ?? [];
//         } catch (error) {
//             throw new Error(
//                 error.response?.data?.message ||
//                 "Failed to load articles."
//             );
//         }
//     },
// };